import {EmptyControl, HvlBaseModel, Required} from '@hvlng/framework-bff/core';
import {JsonObject, JsonProperty} from 'json2typescript';
import {HvlDateConverter} from '@hvlng/framework-bff/util';
import {CodeTextDiscriminatorModel, FileOwnershipModel} from 'humanresources-common-shared';
import {PerIdentityModel} from './per-identity-model';

@JsonObject('KovanHrPerPeopleModel')
export class PerPeopleModel extends HvlBaseModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

    @Required()
    @JsonProperty('count', Number, true)
    count: number = null;

    @Required()
    @JsonProperty('peopleNum', Number, true)
    peopleNum: number = null;

    @Required()
    @JsonProperty('perPeopleStatusId', Number, true)
    perPeopleStatusId: number = null;

    @JsonProperty('perPeopleStatus', CodeTextDiscriminatorModel, true)
    perPeopleStatus: CodeTextDiscriminatorModel = null;

    @EmptyControl()
    @JsonProperty('perOrganizationId', Number, true)
    perOrganizationId: number = null;

    @EmptyControl()
    @JsonProperty('nameSurname', String, true)
    nameSurname: string = null;

    @EmptyControl()
    @JsonProperty('registryNumber', String, true)
    registryNumber: string = null;

    @EmptyControl()
    @JsonProperty('picture', FileOwnershipModel, true)
    picture: FileOwnershipModel = null;

    @EmptyControl()
    @JsonProperty('employee', Boolean, true)
    isEmployee: boolean = null;

    @EmptyControl()
    @JsonProperty('name', String, true)
    name: string = null;

    @EmptyControl()
    @JsonProperty('surname', String, true)
    surname: string = null;

    @EmptyControl()
    @JsonProperty('birthDate', HvlDateConverter, true)
    birthDate: Date = null;

    @EmptyControl()
    @JsonProperty('identificationNumber', String, true)
    identificationNumber: string = null;

    @EmptyControl()
    @JsonProperty('active', Boolean, true)
    isActive: boolean = null;

    @Required()
    @JsonProperty('startDate', HvlDateConverter, true)
    startDate: Date = null;

    @EmptyControl()
    @JsonProperty('perIdentityList', [Object], true)
    perIdentityList?: PerIdentityModel[] = [];
}
